import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  IconButton,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import Loader from "../Common/Loader";
import SnackbarComponent from "../Common/SnackbarComponent";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoicePDF from "./InvoicePdf";
import { Print } from "@mui/icons-material";
import Spinner from "../Common/Spinner";
import api from "../Auth/Middleware";

const AddFeesDialog = ({
  open,
  onClose,
  studentDetail,
  id,
  onSuccess,
  onFail,
}) => {
  const [loading, setLoading] = useState(true);
  const [feesData, setFeesData] = useState(null);
  const [totalFees, setTotalFees] = useState("");
  const [dateOfPayment, setDateOfPayment] = useState("");
  const [nextDue, setNextDue] = useState("");
  const [paidAmount, setPaidAmount] = useState("");
  const [pendingAmount, setpendingAmount] = useState("");
  const [snackbarMsg, setSnackbarMSg] = useState("");
  const [snackbarSevierty, setSnackbarSevierty] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    // Fetch fees data from API
    const fetchData = async () => {
      try {
        const response = await api.get(`Student/Fees/${id}`);
        setFeesData(response.data);
        setTotalFees(response?.data[0]?.total);
        setLoading(false);
      } catch (error) {
        setSnackbarOpen(true);
        setSnackbarMSg("Something went Wrong!! Please refresh the page");
        setSnackbarSevierty("error");
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    if (feesData) {
      const sum = feesData.reduce(
        (accumulator, currentValue) => accumulator + currentValue.amoutPaid,
        0
      );
      setpendingAmount(feesData[0]?.total - sum);
    }
  }, [feesData]);

  const handleAddFees = async () => {
    if (
      !totalFees ||
      isNaN(parseFloat(totalFees)) ||
      parseFloat(totalFees) <= 0
    ) {
      setSnackbarOpen(true);
      setSnackbarMSg("Please enter a valid total amount");
      setSnackbarSevierty("warning");
      return;
    }

    if (!dateOfPayment) {
      setSnackbarOpen(true);
      setSnackbarMSg("Please enter a valid date of payment");
      setSnackbarSevierty("warning");
      return;
    }

    if (nextDue && nextDue <= dateOfPayment) {
      setSnackbarOpen(true);
      setSnackbarMSg("Next due date can't be less than date of payment ");
      setSnackbarSevierty("warning");
      return;
    }

    if (
      !paidAmount ||
      isNaN(parseFloat(paidAmount)) ||
      parseFloat(paidAmount) <= 0
    ) {
      setSnackbarOpen(true);
      setSnackbarMSg("Please enter a valid amount ");
      setSnackbarSevierty("warning");
      return;
    }

    if (paidAmount > pendingAmount) {
      setSnackbarOpen(true);
      setSnackbarMSg(
        "Please enter valid amount. Paid amount cannot be more than pending amount"
      );
      setSnackbarSevierty("warning");
      return;
    }

    const data = {
      studentId: id,
      amountPaid: parseFloat(paidAmount),
      submitDate: dateOfPayment,
      nextDue: nextDue ? nextDue : null,
      totalAmount: parseFloat(totalFees),
    };

    try {
      await api.post('Student/AddFees', data);
      onSuccess();
      onClose();
    } catch (error) {
      onFail();
      onClose();
    }
  };

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };


  return (
    <>
      <SnackbarComponent
        open={snackbarOpen}
        severity={snackbarSevierty}
        message={snackbarMsg}
        onClose={closeSnackbar}
      ></SnackbarComponent>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Add Fees for {studentDetail.name}</DialogTitle>
        <DialogContent>
          {loading ? (
            // Show loading indicator or skeleton UI here while data is being fetched
            <Loader />
          ) : feesData && feesData.length > 0 ? (
            <div>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Paid Amount</TableCell>
                    <TableCell>Date of Payment</TableCell>
                    <TableCell>Next Due</TableCell>
                    <TableCell>Invoice</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {feesData.map((fee) => (
                    <TableRow key={fee.id}>
                      {/* <TableCell>{fee.total}</TableCell> */}
                      <TableCell>{fee.amoutPaid}</TableCell>
                      <TableCell>
                        {new Date(fee.date).toLocaleDateString("en-GB")}
                      </TableCell>
                      <TableCell>
                        {new Date(fee.nextDue).toLocaleDateString("en-GB")}
                      </TableCell>
                      <TableCell>
                       
                        <PDFDownloadLink
                          document={<InvoicePDF feesData={fee} studentData={studentDetail}/>}
                          fileName={`INV_${studentDetail.name.replace(/ /g, "_")}.pdf`}
                        >
                          {({ loading }) =>
                            loading ? (
                             <Spinner/>
                            ) : (
                              <IconButton
                              color="info"
                              aria-label="Print"
                            >
                              <Print />
                            </IconButton>
                            )
                          }
                        </PDFDownloadLink>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <div className="my-3">
                <Stack direction="row" spacing={2}>
                  <Chip
                    color="info"
                    label={`Total Fees: \u20B9${feesData[0]?.total}`}
                  />
                  <Chip
                    color="secondary"
                    label={`Pending Fees: \u20B9${pendingAmount}`}
                  />
                </Stack>
              </div>
              <>
                <div className="my-2">
                  <Box display="flex" flexDirection="column" gap={2}>
                    <h4>Add new installment</h4>
                    <TextField
                      label="Date of Payment"
                      type="date"
                      required
                      value={dateOfPayment}
                      onChange={(e) => setDateOfPayment(e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      label="Next Due"
                      type="date"
                      value={nextDue}
                      onChange={(e) => setNextDue(e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      label="Paid Amount"
                      type="number"
                      value={paidAmount}
                      onChange={(e) => setPaidAmount(e.target.value)}
                    />
                  </Box>
                </div>
              </>
            </div>
          ) : (
            <>
              <div className="my-2">
                <Box display="flex" flexDirection="column" gap={2}>
                  <TextField
                    label="Total Fees"
                    required
                    value={totalFees}
                    type="number"
                    onChange={(e) => setTotalFees(e.target.value)}
                  />
                  <TextField
                    label="Date of Payment"
                    value={dateOfPayment}
                    type="date"
                    onChange={(e) => setDateOfPayment(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    label="Next Due"
                    value={nextDue}
                    type="date"
                    onChange={(e) => setNextDue(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    label="Paid Amount"
                    value={paidAmount}
                    type="number"
                    onChange={(e) => setPaidAmount(e.target.value)}
                  />
                </Box>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleAddFees} variant="contained" color="primary">
            Add Fees
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddFeesDialog;
